import { IonContent } from '@ionic/react';
import React, { useState, useEffect } from 'react';

interface QuestionData {
    sentence: string;
    correctAnswer: string;
    options: string[];
}

const WordAddition: React.FC = () => {
    const [showImage, setShowImage] = useState(false);
    const [question, setQuestion] = useState<QuestionData[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [userInput, setUserInput] = useState<string>("");
    const [error, setError] = useState(false);

    function shuffleArray(array: any[]) {
        for (let i = array.length - 1; i > 0; i--) {
            // Generate a random index
            const randomIndex = Math.floor(Math.random() * (i + 1));

            // Swap elements
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    }

    // Fetch question data from an external source (replace with your actual API or JSON URL)
    const fetchQuestions = async () => {

        fetch(process.env.REACT_APP_API_URL + 'WordAddition.json')
            .then((response) => response.json())
            .then((data) => {
                setQuestion(shuffleArray(data));
            })
            .catch((error) => {
                console.error('Error loading images:', error);
            });
    };

    useEffect(() => {

        fetchQuestions();
        document.title = "Mamas Guidance - Class One - Mathematics - Addition - Word Problem"; // Set page title
    }, []);

    // Handle form submission
    const handleSubmit = (selectedAnswer: string) => {
        const correctAnswer = question[currentIndex].correctAnswer;
        if (selectedAnswer === correctAnswer) {
            setShowImage(true);
            let nextIndex;
            // Generate a new question after a delay
            setTimeout(() => {
                if (currentIndex + 1 < question.length) {
                    nextIndex = currentIndex + 1;
                }
                else {
                    nextIndex = 0;
                }
                setCurrentIndex(nextIndex);
                setUserInput("");
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setError(true);
        }
    };

    return (
        <>

            {
                showImage === false ?
                    <>
                        <div className='contentPart showCenter additionWord'>
                            <div className='questionContainer'>
                                {question.length > 0 && (
                                    <h3 className='questionWord'>{question[currentIndex].sentence}</h3>
                                )}
                            </div>
                            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                {/* <div className='middle-grid'> */}
                                {question[currentIndex]?.options.map((option, index) => (
                                    <div
                                        key={index}
                                        className={`background-blue `}
                                        onClick={() => handleSubmit(option)}
                                        style={{ width: 'auto', padding: '10px', minWidth: "60px" }}
                                    >
                                        {option}
                                    </div>
                                ))}
                                {/* </div> */}
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default WordAddition;